import styled from 'styled-components';
import { colors } from '../../utils';
import Accordion from '@mui/material/Accordion';
import { TextView } from 'components';
import { ASSETS } from '../../utils/config';

export const Wrapper = styled.div`
  width: 65vw;
  min-width: 700px;
  margin: auto;
  margin-top: 40px;
`;
export const InviteFriendsContainer = styled.div`
  background-color: ${colors.white};
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 20px 0px;
  padding: 24px;
  padding-top: 36px;
`;

export const InviteFriendsTitle = styled(TextView)`
  color: ${colors.primary};
  font-size: 20px;
  font-weight: 700;
  margin-left: 8px;
`;

export const ToRowDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

export const InviteIcon = styled.img`
  width: 32px;
  height: 32px;
`;

export const Label = styled(TextView)`
  color: ${colors.darkGrey};
  font-size: 14px;
  font-weight: 400;
`;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 20px;
  margin-top: 20px;
  border-bottom: 0.5px solid ${colors.lightGrey};
  width: 60%;
`;

export const GalleryLink = styled.div`
  padding: 6px;
  background-color: #f6f7f9;
  border-radius: 4px;
  width: 90%;
  heigh: 40px;
  margin-top: 10px;
`;

export const LinkText = styled(TextView)`
  color: ${colors.lightGrey};
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
`;

export const QrContainer = styled.div`
  margin-top: 20px;
  margin-bottom: 20px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const QrCode = styled.img`
  width: 128px;
  height: 128px;
  margin-top: 5px;
`;

export const ShareIcons = styled.img`
  width: 9%;
  height: 30px;
  margin-top: 10px;
  cursor: pointer;
`;

export const SideBarOpened = styled.div`
  width: 20vw;
  height: 86vh;
  background-color: ${colors.white};
  border-radius: 10px;
`;

export const SideBarHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 8vh;
  padding-left: 14px;
  border-bottom: 1px solid rgb(225, 225, 225);
`;

export const Row = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

export const SideBarContent = styled.div`
  overflow-y: scroll;
  overflow-x: hidden;
  height: 79vh;
  padding-left: 15px;
  padding-top: 15px;
`;

export const MenuItem = styled(Accordion)`
  margin-top: 0px;
  box-shadow: none;
  border: none;
  outline: none;
`;

export const MenuItemHeader = styled.h3`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  border-radius: 5px;
  padding: 10px;
  ${({ isSelected }) =>
    isSelected &&
    `
    background-color: ${colors.background};
  `}
`;

export const MenuItemIcon = styled.img`
  width: 16px;
  height: 16px;
  color: ${colors.darkGrey};
  transform: rotate(270deg);
  opacity: ${({ isSelected }) => (isSelected ? 1 : 0.5)};
`;

export const SideBarIcon = styled.img`
  width: 30px;
  height: 30px;
  opacity: ${({ isSelected }) => (isSelected ? 1 : 0.5)};
`;

export const CenterWrapper = styled.div`
  background-color: ${colors.white};
  border-radius: 10px;
  margin: 0px 2vw;
  padding: 3vw;
`;

export const ContentHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const HeaderIcon = styled.img`
  margin-right: 10px;
  width: 40px;
  height: 40px;
`;

export const Content = styled.div`
  width: 80%;
  margin-top: 20px;
`;

export const InputRow = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 16px;
`;

export const InputWrapper = styled.div`
  margin-bottom: 16px;
`;

export const Input = styled.input`
  width: 100%;
  background-color: ${colors.background};
  border-radius: 5px;
  height: 36px;
  outline: none;
  border: none;
  padding: 5px 10px;
  margin-top: 5px;
`;

export const TextArea = styled.textarea`
  width: 100%;
  background-color: ${colors.background};
  border-radius: 5px;
  height: 100px;
  outline: none;
  border: none;
  padding: 5px 10px;
  margin-top: 5px;
`;

export const ImagePlaceholder = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: ${colors.background};
  overflow: hidden;
  margin-bottom: 16px;
  margin-top: 5px;
`;

export const UserImage = styled.img`
  width: 100%;
  height: 100%;
`;

export const Error = styled(TextView)`
  color: ${colors.error};
  position: absolute;
  margin-top: -24px;
`;

export const Item = styled.div``;
